import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveTargetedFinancialInstrumentsMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveTargetedFinancialInstrumentsParam } from 'api/types/params';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveTargetedFinancialInstruments = () => {
  const [
    saveTargetedFinancialInstruments,
    { data, loading, error: apolloError },
  ] = useLegalClientSaveTargetedFinancialInstrumentsMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveTargetedFinancialInstruments
      ? parseLegalClient(data.legalClientSaveTargetedFinancialInstruments)
      : undefined,
    loading,
    error,
    saveTargetedFinancialInstruments: useCallback(
      async (
        id: string,
        params: LegalClientSaveTargetedFinancialInstrumentsParam
      ) => {
        const res = await saveTargetedFinancialInstruments({
          variables: {
            id,
            input: params,
          },
        });
        return res.data?.legalClientSaveTargetedFinancialInstruments
          ? parseLegalClient(
              res.data.legalClientSaveTargetedFinancialInstruments
            )
          : undefined;
      },
      [saveTargetedFinancialInstruments]
    ),
  };
};
